export enum ProfileTab {
  Information = "Information",
  Certificates = "Certificates",
}
